import styled from 'styled-components';
import { baseVariables } from '../../styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
`;

export const EyebrowWrapper = styled.div`
  margin-block-end: 0;
`;

export const HeaderWrapper = styled.div`
  margin-block-end: 0;
`;

export const SubheaderWrapper = styled.div`
  margin-block-end: 0;
`;

export const ParagraphWrapper = styled.div`
  margin-block-end: 0;
`;

export const BlockquoteWrapper = styled.div``;

export const MediaCaptionWrapper = styled.div`
  margin-block-start: 1.5rem;
`;

export const ButtonWrapper = styled.div`
  margin-block-start: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;

  @media ${baseVariables.mediaQuery.md} {
    margin-block-start: 1.5rem;
    gap: 1.5rem;
  }
`;
